/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Checkbox } from '@chakra-ui/react';
import { useField } from 'react-final-form';
import styled from '@emotion/styled';

const CheckboxStyled = styled(Checkbox)`
  .chakra-checkbox__control {
    &[data-checked] {
      background: ${({ theme }) => theme.colors.highlight};
      border-color: ${({ theme }) => theme.colors.highlight};

      :hover {
        background: ${({ theme }) => theme.colors.highlight};
        border-color: ${({ theme }) => theme.colors.highlight};
      }

      svg {
        margin-top: 1px;
      }
    }

    &[data-invalid] {
      border-color: inherit;
    }

    &[data-disabled] {
      background: inherit;
    }

    border-radius: 4px;
  }
`;

export const CheckboxArrayControl: React.FC<any> = ({
  name,
  value,
  children,
  isDisabled,
  ...rest
}) => {
  const {
    input: { checked, ...input },
    meta: { error, touched },
  } = useField(name, {
    type: 'checkbox',
    value,
  });

  return (
    <CheckboxStyled
      {...rest}
      {...input}
      isChecked={checked}
      isDisabled={isDisabled}
      isInvalid={error && touched}
      iconSize={20}
    >
      {children}
    </CheckboxStyled>
  );
};
